import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import ElementIcon from "../../../../../../components/element-icon/ElementIcon";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import './MagicSchoolsPage.scss'

interface MagicSchoolsPageProps {
}

const MagicSchoolsPage = (props: MagicSchoolsPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Schools - Chase the Fox`,
        description: "Learn about the various schools in Casarok's magic system!",
        keywords: ["casarok", "magic", "magic compendium", "magic system", "magic school", "magical schools", "elemental categories"],
        imgSrc: `chase/world/magic/schools/preview.png`,
        url: `world/magic/schools`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Schools of Magic">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <p>
                        All magic in Casarok is divided into four schools. Each school of magic has a different method
                        for tapping into specific powers via a user's mana. Elements that use similar methodologies in
                        this way are considered to be in the same school. A school has four elements associated it with
                        some overlap between schools.
                    </p>
                    <p className="center">
                        <ElementIcon className="magic-element-header" name="fire"/>
                        <ElementIcon className="magic-element-header" name="frost"/>
                        <ElementIcon className="magic-element-header" name="lightning"/>
                        <ElementIcon className="magic-element-header" name="space"/>
                    </p>
                    <p>
                        <strong>The School of the Arcane</strong> deals with the use of mana to manipulate the energy
                        in the world around them. Some elements, such as Frost and Space can utilize physical forces,
                        but for the most part they are magical energies. It takes a keen intellect to gain knowledge
                        in the realm of physics to use arcane magic as well as the willpower to impose your resolve on
                        these forces. Masters of the arcane arts are known as <em>mages</em>.
                    </p>
                    <p className="center">
                        <ElementIcon className="magic-element-header" name="water"/>
                        <ElementIcon className="magic-element-header" name="wind"/>
                        <ElementIcon className="magic-element-header" name="earth"/>
                        <ElementIcon className="magic-element-header" name="time"/>
                    </p>
                    <p>
                        <strong>The School of the Elements</strong> works with bending the forces of the planet itself.
                        Most of its power is physical in nature, though some elements in this school draw from the deep
                        geological time span of Casarok, particularly the elements of Earth and Time. Perception of the
                        world around one is important. It takes great perception to acknowledge these elements as well
                        as the intellect to grasp an understanding of chemistry and learn the atomic makeup of the
                        objects
                        being manipulated. Masters of the four elemental arts are known as <em>thaumaturges</em>.
                    </p>
                    <p className="center">
                        <ElementIcon className="magic-element-header" name="nature"/>
                        <ElementIcon className="magic-element-header" name="spirit"/>
                        <ElementIcon className="magic-element-header" name="light"/>
                        <ElementIcon className="magic-element-header" name="dark"/>
                    </p>
                    <p>
                        <strong>The School of the Metaphysical</strong> teaches the use of intangible forces. These
                        forces can be observed and studied, but they cannot be perceived with the fundamental senses.
                        All these elements are capable of healing, each with its own method of doing so. In order to
                        become capable in the realm of the metaphysical, a caster needs the willpower to bend these
                        unseen forces as well as the perception to grasp their presence. Masters of the four elements
                        of this school are known as <em>wizards</em>.
                    </p>
                    <p className="center">
                        <ElementIcon className="magic-element-header" name="light"/>
                        <ElementIcon className="magic-element-header" name="dark"/>
                        <ElementIcon className="magic-element-header" name="space"/>
                        <ElementIcon className="magic-element-header" name="time"/>
                    </p>
                    <p>
                        <strong>The School of the Divine</strong> encapsulates the strongest known magic powers in
                        the universe. These are powers that can only be understood or granted by
                        the <NavLink className="world-link glowing" to="/world/religion/pantheon">gods and goddesses</NavLink> of
                        Casarok. As such, the only mortals that can use divine magic powers are their direct emissaries.
                        These include <em>champions</em> and <em>oracles</em> though sometimes they are wielded by
                        their lesser counterparts, <em>agents</em> and <em>priests or priestesses</em>.
                    </p>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicSchoolsPage;